import React, { lazy, useEffect, useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@material-ui/core';
import BannerCarousel from './BannerCarousel';
import Providers from './ProvidersInfo';
import './HomePage.scss';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { connect } from 'react-redux';
import { RootState } from '../../models/RootState';
import { DcGameNew } from '../../models/dc/DcGame';
import SitesInfo from './SiteInfo';
import GamesCarousel from './GamesCarousel';
import { AxiosResponse } from 'axios';
import SVLS_API from '../../svls-api';
import { setTrendingGames } from '../../store/common/commonActions';
import { CasinoGameDTO } from '../../models/IndianCasinoState';

import { isMobile } from 'react-device-detect';
import { useHistory } from 'react-router';
import CheckBonusTab from './CheckBonusTab';
import BottomTab from './BottomTab';
import { DomainConfig } from '../../models/DomainConfig';

const SportsCarousel = lazy(() => import('./SportsCarousel'));

type StoreProps = {
  allowedConfig: number;
  trendingGames: DcGameNew[];
  setTrendingGames: Function;
  loggedIn: boolean;
  loggedInUserStatus: any;
  setCasinoGame: (cGame: CasinoGameDTO) => void;
  langData: any;
  domainConfig: DomainConfig;
};

const HomePage: React.FC<StoreProps> = (props) => {
  const {
    allowedConfig,
    trendingGames,
    setTrendingGames,
    loggedIn,
    loggedInUserStatus,
    setCasinoGame,
    langData,
    domainConfig,
  } = props;
  const [macGames, setMacGames] = useState<DcGameNew[]>();
  const [evolutionGames, setEvolutionGames] = useState<DcGameNew[]>();
  const [showDialog, setShowDialog] = useState<boolean>(false);
  const history = useHistory();
  const setDialogShow = (show: boolean) => {
    setShowDialog(show);
  };

  const trendingGameNames = [
    'Diamonds',
    'Dice',
    'Hilo',
    'Limbo',
    'Plinko',
    'X-Roulette',
    'Mines',
    'Crash X',
    'Color Game',
    '5D Lottery',
    'K3 Lottery 1',
    'Bolly Kiss',
  ];

  const getGames = async () => {
    let response = await SVLS_API.get(
      '/catalog/v2/categories/indian-casino/games/',
      {
        params: {
          providerId: 'INPLM,MAC88,DC',
          trending: true,
        },
      }
    );

    let macGames = response.data.filter(
      (game) => game.subProviderName == 'Mac88 Gaming'
    );
    let trendingGames = response.data.filter((game) =>
      trendingGameNames
        .map((gameName) => gameName.toLowerCase())
        .includes(game.gameName.toLowerCase())
    );
    let evolutionGames = response.data.filter(
      (game) => game.subProviderName == 'Evolution'
    );

    setMacGames(macGames);
    setTrendingGames(trendingGames);
    setEvolutionGames(evolutionGames);
  };

  useEffect(() => {
    getGames();
  }, []);

  return (
    <div className="home-page-ctn">
      <div className="home-container">
        <CheckBonusTab loggedIn={loggedIn} langData={langData}></CheckBonusTab>
        <BannerCarousel />
        {isMobile && <SportsCarousel></SportsCarousel>}
        <GamesCarousel
          loggedIn={loggedIn}
          setDialogShow={setDialogShow}
          setCasinoGame={setCasinoGame}
          loggedInUserStatus={loggedInUserStatus}
          trendingGames={trendingGames}
          displayHeader={langData?.['popular_games']}
          heading="Popular Games"
        />

        <SitesInfo
          loggedIn={loggedIn}
          setDialogShow={setDialogShow}
          setCasinoGame={setCasinoGame}
          loggedInUserStatus={loggedInUserStatus}
          langData={langData}
        />
        <GamesCarousel
          loggedIn={loggedIn}
          setDialogShow={setDialogShow}
          setCasinoGame={setCasinoGame}
          loggedInUserStatus={loggedInUserStatus}
          trendingGames={macGames}
          displayHeader={langData?.['recommended_games']}
          heading="Recommended Games"
        />

        {/* <GamesCarousel
          loggedIn={loggedIn}
          setDialogShow={setDialogShow}
          setCasinoGame={setCasinoGame}
          loggedInUserStatus={loggedInUserStatus}
          trendingGames={rgGames}
          heading={langData?.['top_rated_games']}
        />

        {/* <DepositBonus /> */}
        <GamesCarousel
          loggedIn={loggedIn}
          setDialogShow={setDialogShow}
          setCasinoGame={setCasinoGame}
          loggedInUserStatus={loggedInUserStatus}
          trendingGames={evolutionGames}
          displayHeader={langData?.['live_casino_games']}
          heading="Live Casino Games"
        />

        <Providers langData={langData} />

        <BottomTab
          langData={langData}
          supportContacts={domainConfig.suppportContacts}
        />

        <div className="banner-container pb-0"></div>
      </div>

      <Dialog
        open={showDialog}
        onClose={() => setDialogShow(false)}
        aria-labelledby="form-dialog-title"
        maxWidth="xs"
        className="login-alert"
      >
        <DialogTitle id="form-dialog-title">{langData?.['notice']}</DialogTitle>
        <DialogContent>
          <div className="dc-dialog-body">
            {langData?.['games_access_login_txt']}
          </div>
        </DialogContent>
        <DialogActions className="dc-dialog-actions">
          <Button
            onClick={() => setDialogShow(false)}
            className="cancel-btn dialog-action-btn"
          >
            {langData?.['cancel']}
          </Button>
          <Button
            onClick={() => {
              history.push('/login');
              setDialogShow(false);
            }}
            className="login-btn dialog-action-btn"
          >
            {langData?.['login']}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

const mapStateToProps = (state: RootState) => {
  let status = 0;
  if (state.auth.loggedIn) {
    status = JSON.parse(
      window.atob(sessionStorage.getItem('jwt_token').split('.')[1])
    ).status;
  }
  return {
    loggedIn: state.auth.loggedIn,
    allowedConfig: state.common.allowedConfig,
    trendingGames: state.common.trendingGames,
    loggedInUserStatus: status,
    langData: state.common.langData,
    domainConfig: state.common.domainConfig,
  };
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    setTrendingGames: (value) => dispatch(setTrendingGames(value)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(HomePage);
